
export interface UpdateFuelReceiptRequest {
    id: number;
    fuelUpliftLtr: number | null | undefined;
    density: number | null | undefined;
    receiptDate: Date;
}
